(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('CartController', CartController);

    CartController.$inject = ['$log','Principal', 'CartFactory', 'CartService', '$translate', '$rootScope', '$state', 'CartLabelService'];

    function CartController($log,Principal, CartFactory, CartService, $translate, $rootScope, $state, CartLabelService) {
        var vm = this;

        vm.itemCount = CartFactory.count();
        vm.totalPrice = CartFactory.totalPrice();
        vm.cart = CartFactory.getCart();
        vm.cartFactory = CartFactory;
        vm.areaCount = CartFactory.countAreas();
        vm.lang = $translate.use();
        vm.mustBookArea = false;
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        Principal.hasAuthority('PRE_AUTHORIZED').then(function (hasAuthority) {
            if (hasAuthority) {
                vm.mustBookArea = true;
            }else{
                vm.areaCount = 100;
            }
        });

        vm.openCart = openCart;
        vm.remove = removeItem;
        vm.goToSummary = goToSummary;
        vm.getLabelForItem = getLabelForItem;

        function openCart() {
            vm.cart = CartFactory.getCart();
            CartService.open();
        }

        function removeItem(item) {
            CartFactory.removeItem(item);
            if(vm.mustBookArea)
                vm.areaCount = CartFactory.countAreas();
        }

        function goToSummary() {
            CartService.close();
            $state.go('summary');
        }

        function getLabelForItem(item) {
           return CartLabelService.getCartLabelForItem(item, vm.lang);
        }

        return vm;
    }
})();
